<p-dialog
  [(visible)]="visible"
  [header]="channel === 'EMAIL' ? 'Send Email' : 'Send SMS'"
  [modal]="true"
  [closable]="true"
  (onHide)="close()"
  [style]="{ width: '480px' }"
>
  <div class="bcd-body">
    <div class="bcd-to" *ngIf="row">
      <span class="bcd-to-label">To:</span>
      <span class="bcd-to-name">{{ row.fullName || row.ownerLeadName || 'Lead' }}</span>
    </div>

    <div class="bcd-channel-toggle">
      <button class="bcd-ch-btn" [class.active]="channel === 'EMAIL'" (click)="channel = 'EMAIL'">
        <i class="pi pi-envelope"></i> Email
      </button>
      <button class="bcd-ch-btn" [class.active]="channel === 'SMS'" (click)="channel = 'SMS'">
        <i class="pi pi-mobile"></i> SMS
      </button>
    </div>

    <div class="bcd-subject" *ngIf="channel === 'EMAIL'">
      <input type="text" class="bcd-input" [(ngModel)]="subject" placeholder="Subject" />
    </div>

    <div class="bcd-body-field">
      <textarea class="bcd-textarea" [(ngModel)]="body" [placeholder]="channel === 'EMAIL' ? 'Email body...' : 'SMS message (160 chars recommended)'" rows="6"></textarea>
      <div class="bcd-char-count" *ngIf="channel === 'SMS'">{{ body.length }} chars</div>
    </div>

    <div class="bcd-error" *ngIf="errorMsg">{{ errorMsg }}</div>
  </div>

  <ng-template pTemplate="footer">
    <button class="bcd-cancel-btn" (click)="close()">Cancel</button>
    <button class="bcd-send-btn" (click)="send()" [disabled]="!body.trim() || sending">
      <i class="pi pi-send"></i> {{ sending ? 'Sending...' : 'Send' }}
    </button>
  </ng-template>
</p-dialog>
